import {
    PERSONAL_INFO_REQUEST,
    PERSONAL_INFO_ERROR,
    PERSONAL_INFO_SUCCESS,
    PERSONAL_INFO_DETAILS_REQUEST,
    PERSONAL_INFO_DETAILS_SUCCESS,
    PERSONAL_INFO_DETAILS_ERROR,
    PERSONAL_INFO_RESET_VALUE,
    GET_KYC_FROM_BACKEND,
    GET_KYC_FROM_BACKEND_SUCCESS,
    GET_KYC_FROM_BACKEND_ERROR,
    PERSONAL_INFO_REQ_VALUE,
    PERSONAL_INFO_REQUEST_SECOND,
    PERSONAL_INFO_SEND_DETAILS_SUCCESS,
    PERSONAL_INFO_SEND_DETAILS_ERROR,
    PERSONAL_INFO_SEND_DETAILS_RESET
} from "../actionType";

const initialState = {
    isLoading: false,
    personalInfoData: null,
    personalInfoValue: null,
    personalInputValue: null,
    error: null,
    ckycDetailsError: null,
    ckycDetails: null,
    kycBackedData: null,
    kycBackedError:null,
    genderData:['Male', 'Female',],
    tokenReq:null,
    personalInfoSecondInput:null,
    personalInfoSendDetails: null,
    personalInfoSendDetailsError: null
};

const personalInfoReducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case PERSONAL_INFO_REQ_VALUE:
            return {
                ...state,
                isLoading: true,
                personalInputValue: payload,
            }
        case PERSONAL_INFO_REQUEST:
            return {
                ...state,
                isLoading: false,
                tokenReq:payload
            }
        case PERSONAL_INFO_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload,
            }
        case PERSONAL_INFO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                personalInfoData: payload
            }
        case PERSONAL_INFO_DETAILS_REQUEST:
            return {
                ...state,
                isLoading: false,
            }
        case PERSONAL_INFO_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ckycDetails: payload
            }
        case PERSONAL_INFO_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
                ckycDetailsError: payload,
            }
        case PERSONAL_INFO_RESET_VALUE:
            return {
                ...state,
                isLoading: false,
                personalInfoData: null, //uncommneted to reset the value
                error: null,
            }
        case GET_KYC_FROM_BACKEND:
            return {
                ...state,
                isLoading: false,
            }
        case GET_KYC_FROM_BACKEND_SUCCESS:
            return {
                ...state,
                isLoading: false,
                kycBackedData: payload,
            }
        case GET_KYC_FROM_BACKEND_ERROR:
            return {
                ...state,
                isLoading: false,
                kycBackedError: payload,
            }
        case PERSONAL_INFO_REQUEST_SECOND:
            return {
                ...state,
                isLoading: false,
                personalInfoSecondInput: payload,
            }
        case PERSONAL_INFO_SEND_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                personalInfoSendDetails: payload,
            }
        case PERSONAL_INFO_SEND_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
                personalInfoSendDetailsError: payload,
            }
        case PERSONAL_INFO_SEND_DETAILS_RESET:
            return {
                ...state,
                isLoading: false,
                personalInfoSendDetails: null,
            }
            
        default:
            return state;
    }
}
export default personalInfoReducer;
